/* Hemmadjur: fast köprad på mobilen från första sekunden.
   Temat visar annars köpraden först när man har scrollat förbi köpknappen.
   Här visas den direkt på mobilen. Så länge köpknappen ligger längre ner
   leder radens knapp till valen (storlek, färg, antal) i stället för att
   lägga i varukorgen. När man har scrollat förbi köpknappen tar temat över. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  var scriptSrc = document.currentScript && document.currentScript.src;

  /* Storleksguide direkt vid storleksvalet (bara där sidan har en #storleksguide). */
  function sizeHelp(section) {
    var guide = document.getElementById('storleksguide');
    if (!guide) return;
    function go(event) {
      event.preventDefault();
      guide.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function ensure() {
      var fieldsets = section.querySelectorAll('variant-picker fieldset');
      Array.prototype.forEach.call(fieldsets, function (fs) {
        var legend = fs.querySelector('legend');
        if (!legend || legend.textContent.trim().toLowerCase().indexOf('storlek') !== 0) return;
        if (!legend.querySelector('.hd-size-link')) {
          var link = document.createElement('a');
          link.href = '#storleksguide';
          link.className = 'hd-size-link';
          link.textContent = 'Storleksguide';
          link.addEventListener('click', go);
          legend.appendChild(link);
        }
        var next = fs.nextElementSibling;
        if (!next || !next.classList.contains('hd-size-help')) {
          var help = document.createElement('p');
          help.className = 'hd-size-help';
          help.innerHTML = 'Osäker? Mät hundens bröst och jämför med <a href="#storleksguide" data-hd-guide>storleksguiden</a>, eller <a href="mailto:kontakt@hemmadjur.se?subject=Storlekshj%C3%A4lp">mejla oss måtten</a> så hjälper vi dig. Fel storlek går att byta.';
          help.querySelector('[data-hd-guide]').addEventListener('click', go);
          fs.insertAdjacentElement('afterend', help);
        }
      });
    }
    ensure();
    new MutationObserver(ensure).observe(section, { childList: true, subtree: true });
  }

  /* Förslag i varukorgen som ger fri frakt: ladda modulen även när varukorgen fylls efteråt. */
  function loadUpsell() {
    var src = scriptSrc;
    if (!src) {
      var tag = document.querySelector('script[src*="hemmadjur-sticky.js"]');
      src = tag && tag.src;
    }
    if (!src) return;
    var url = src.split('?')[0].replace('hemmadjur-sticky.js', 'hemmadjur-cart-upsell.js');
    if (document.querySelector('script[data-hd-upsell-loader]')) return;
    var mod = document.createElement('script');
    mod.type = 'module';
    mod.src = url;
    mod.setAttribute('data-hd-upsell-loader', '');
    document.head.appendChild(mod);
  }

  /* Beräknat leveransdatum i stället för "7–12 arbetsdagar" vid köpknappen.
     Räknar 7 och 12 svenska arbetsdagar från i dag (helger och röda dagar hoppas över). */
  var ETA_FROM = 'Leverans normalt 7–12 arbetsdagar';
  var HD_HOLIDAYS = ['2026-12-24', '2026-12-25', '2026-12-26', '2026-12-31', '2027-01-01', '2027-01-06',
    '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-06', '2027-06-06', '2027-06-25', '2027-06-26',
    '2027-11-06', '2027-12-24', '2027-12-25', '2027-12-26', '2027-12-31'];
  var HD_MONTHS = ['jan', 'feb', 'mars', 'apr', 'maj', 'juni', 'juli', 'aug', 'sep', 'okt', 'nov', 'dec'];
  function stockholmToday() {
    var y, m, d;
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Stockholm', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
      parts.forEach(function (p) {
        if (p.type === 'year') y = +p.value;
        if (p.type === 'month') m = +p.value;
        if (p.type === 'day') d = +p.value;
      });
    } catch (e) {}
    if (!y || !m || !d) {
      var now = new Date();
      y = now.getFullYear(); m = now.getMonth() + 1; d = now.getDate();
    }
    return new Date(Date.UTC(y, m - 1, d));
  }
  function isWorkday(date) {
    var day = date.getUTCDay();
    if (day === 0 || day === 6) return false;
    return HD_HOLIDAYS.indexOf(date.toISOString().slice(0, 10)) === -1;
  }
  function addWorkdays(start, n) {
    var date = new Date(start.getTime());
    while (n > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (isWorkday(date)) n--;
    }
    return date;
  }
  function etaText() {
    var today = stockholmToday();
    var a = addWorkdays(today, 7);
    var b = addWorkdays(today, 12);
    var am = HD_MONTHS[a.getUTCMonth()];
    var bm = HD_MONTHS[b.getUTCMonth()];
    var range = a.getUTCMonth() === b.getUTCMonth()
      ? a.getUTCDate() + '–' + b.getUTCDate() + ' ' + bm
      : a.getUTCDate() + ' ' + am + ' – ' + b.getUTCDate() + ' ' + bm;
    return 'Beräknad leverans: ' + range;
  }
  function deliveryDate() {
    var label;
    try { label = etaText(); } catch (e) { return; }
    function swap(root) {
      if (!root || root.textContent.indexOf(ETA_FROM) === -1) return null;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var node;
      var hit = null;
      while ((node = walker.nextNode())) {
        var value = node.nodeValue;
        var at = value.indexOf(ETA_FROM);
        if (at === -1) continue;
        if (value.slice(0, at).replace(/\s/g, '') !== '✓') continue;
        node.nodeValue = value.replace(ETA_FROM, label);
        hit = node;
      }
      return hit;
    }
    var first = swap(document.querySelector('main') || document.body);
    if (!first || !first.parentElement) return;
    var section = first.parentElement.closest('.shopify-section') || document.querySelector('main');
    if (!section) return;
    new MutationObserver(function () { swap(section); }).observe(section, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    var sticky = document.querySelector('sticky-add-to-cart');
    if (!sticky || sticky.dataset.hdInit === 'true') return;
    var bar = sticky.querySelector('.sticky-add-to-cart__bar');
    var section = sticky.closest('.shopify-section');
    var buyBlock = section && section.querySelector('.buy-buttons-block');
    if (!bar || !buyBlock) return;
    sticky.dataset.hdInit = 'true';
    sizeHelp(section);
    loadUpsell();

    var bundles = section.querySelector('hd-bundle-selector-component');
    var legends = Array.prototype.map.call(
      section.querySelectorAll('variant-picker fieldset legend'),
      function (l) { return l.textContent.trim().toLowerCase(); }
    );
    var hasChoices = legends.length > 0 || !!bundles;
    var label = 'Välj variant';
    if (legends.some(function (n) { return n.indexOf('storlek') === 0; })) {
      label = bundles ? 'Välj storlek och antal' : 'Välj storlek';
    } else if (legends.some(function (n) { return n.indexOf('färg') === 0; })) {
      label = 'Välj färg';
    } else if (bundles) {
      label = 'Välj antal';
    }
    bar.style.setProperty('--hd-jump-label', JSON.stringify(label));

    function target() {
      return section.querySelector('variant-picker') || bundles || buyBlock;
    }

    var ticking = false;
    function update() {
      ticking = false;
      if (sticky.dataset.variantAvailable !== 'true') return;
      if (!mq.matches) {
        if (bar.dataset.hdEarly === 'true') {
          bar.dataset.hdEarly = 'false';
          bar.dataset.hdJump = 'false';
          bar.dataset.stuck = 'false';
        }
        return;
      }
      var rect = buyBlock.getBoundingClientRect();
      if (rect.top >= window.innerHeight) {
        bar.dataset.hdEarly = 'true';
        bar.dataset.hdJump = hasChoices ? 'true' : 'false';
        bar.dataset.stuck = 'true';
      } else if (bar.dataset.hdEarly === 'true') {
        bar.dataset.hdEarly = 'false';
        bar.dataset.hdJump = 'false';
        if (rect.bottom > 0) bar.dataset.stuck = 'false';
      }
    }
    function schedule() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    // window + capture så att vi hinner före temats egen klickhantering
    window.addEventListener('click', function (event) {
      if (bar.dataset.hdJump !== 'true') return;
      var button = event.target instanceof Element && event.target.closest('.sticky-add-to-cart__button');
      if (!button || !bar.contains(button)) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var el = target();
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);

    // capture fångar scroll även om sidan scrollar i en inre behållare
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    schedule();
    window.setTimeout(schedule, 600);
  }

  var css = '@media screen and (max-width: 749px){' +
    '.sticky-add-to-cart__bar[data-hd-jump="true"] .sticky-add-to-cart__button{width:auto;padding-inline:var(--padding-lg);}' +
    '.sticky-add-to-cart__bar[data-hd-jump="true"] .add-to-cart-text .svg-wrapper,' +
    '.sticky-add-to-cart__bar[data-hd-jump="true"] .add-to-cart-text__content,' +
    '.sticky-add-to-cart__bar[data-hd-jump="true"] .sticky-add-to-cart__variant{display:none !important;}' +
    '.sticky-add-to-cart__bar[data-hd-jump="true"] .add-to-cart-text::after{content:var(--hd-jump-label);white-space:nowrap;font-weight:600;}' +
       '}' +
    '.hd-size-link{margin-inline-start:12px;font-size:0.8125rem;font-weight:400;text-decoration:underline;color:inherit;}' +
    '.hd-size-help{margin:8px 0 0;font-size:0.8125rem;line-height:1.45;opacity:0.85;}' +
    '.hd-size-help a{color:inherit;text-decoration:underline;}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('DOMContentLoaded', deliveryDate);
  } else {
    init();
    deliveryDate();
  }
})();